export const footerItems = [
  {
    label: 'Home',
    link: '/',
  },
  {
    label: 'Pricing',
    link: '/pricing?from=footer',
  },
  {
    label: 'About',
    link: '/about',
  },
  {
    label: 'Contact',
    link: '/contact?from=footer',
  },
  {
    label: 'Blog',
    link: '/blog',
  },
  {
    label: 'Live Demo',
    link: '/org/demo',
  },
  {
    label: 'Documentation',
    link: '/docs',
  },
  {
    label: 'Security & Privacy',
    link: '/docs/security',
  },
  {
    label: 'Lean AI Framework',
    link: '/lean-ai-framework',
  },
  {
    label: 'Careers',
    link: '/careers',
  },
]